export const actionTypes = {
  REQUEST_START: 'CONTACTS.APPOINTMENT.GET_TAX_AUTHORITIES.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.GET_TAX_AUTHORITIES.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.GET_TAX_AUTHORITIES.REQUEST_FAILURE',
};

export function startRequest(parentId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: parentId,
  };
}

export function requestSuccess(data, parentId) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: { data, parentId },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
